import { render, staticRenderFns } from "./PersonSearchResults.vue?vue&type=template&id=bcca7e04&scoped=true&"
import script from "./PersonSearchResults.vue?vue&type=script&lang=ts&"
export * from "./PersonSearchResults.vue?vue&type=script&lang=ts&"
import style0 from "./PersonSearchResults.vue?vue&type=style&index=0&id=bcca7e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcca7e04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VExpandTransition,VList,VListItem,VRow,VTooltip})
